module.exports = __webpack_public_path__ + "img/icon-attachment.07ed9bed.svg";